import { presetDataType } from "../types/presetData";
import { marketDataType, PlayerMarkets } from "../types/marketFilter";
import { UsStateType } from "../types/usState";
import { Event } from "../types/fixture";
import { defaultTheme, STATS_SELECTION } from "../constants";

export const isOverUnderSelectionType = (objList: Array<{ type: string }>) => {
  for (let obj of objList) {
    if (obj.type === 'over' || obj.type === 'under') {
      return true;
    }
  }
  return false;
}

export const getKeyByValue = <TKey, TValue>(map: Map<TKey, TValue>, value: TValue): TKey | null => {
  let foundKey: TKey | null = null;

  map.forEach((val, key) => {
    if (val === value) {
      foundKey = key;
    }
  });

  return foundKey;
}

export const getCompetitionName = (filterStore: any) => {
  return filterStore.competitions[0] as keyof PlayerMarkets;
}

export const showTypeName = (type: string, typeArr: Array<{ type: string; name: string }>) => {
  const found = typeArr.find((i: { type: string, name: string }) => i.type === type);
  return found ? found.name : null
}

export const getBasedOn = (competition: string, basedOn: { type: string, name: string }[]) => {
  switch (competition) {
    case 'NBA':
      return STATS_SELECTION;
    default:
      return basedOn;
  }
}

export const checkLicensedState = (countryCode: string | null, usStates: UsStateType[]) => {
  if (countryCode) {
    const found = usStates.find((i) => i.id === countryCode);
    return found ? found.status === "licensed" : false;
  }
  return false;
}

export const showDate = (date: string) => {
  switch (date) {
    case 'today':
      return 'Today';
    case 'tomorrow':
      return 'Tomorrow';
    case '3days':
      return '+3 Days';
    case '7days':
      return '+7 Days';
    default:
      return null;
  }
}

export const getBackGroundColor = (sportName: string) => {
  switch (sportName) {
    case 'NBA':
      return defaultTheme.NBA;
    case 'NFL':
      return defaultTheme.NFL;
    case 'NHL':
      return defaultTheme.NHL;
    case 'MLB':
      return defaultTheme.MLB;
    default:
      return defaultTheme.white;
  }
}

export const showGames = (gameIds: string[], games: Event[]) => {
  const getGameName = (id: string) => {
    const found = games.find((i: Event) => i.id === gameIds[0]);
    return found ? `${found.contestant[1].code} @ ${found.contestant[0].code}` : null
  }
  switch (gameIds.length) {
    case 0:
      return 'All Games';
    case 1:
      return getGameName(gameIds[0])
    default:
      return `${gameIds.length} Games`;
  }
}

export const findPresetFilterByCompetition = (competition: string, dataArray: presetDataType[], marketsArray: marketDataType[]) => {
  const foundPreset = dataArray.find((preset: presetDataType) => {
    const foundCompetition = preset.competitions.find((comp) => comp.name === competition && marketsArray.map((i) => i.type).includes(preset.market));
    return foundCompetition;
  });

  return foundPreset ? {
    date: foundPreset.dateFilter,
    market: foundPreset.market,
    basedOn: foundPreset.basedOn,
  } : {
    date: '3days',
    market: 'ML',
    basedOn: 'season',
  };
}

export const convertNameForOrderBy = (type: string, name: string | null) => {
  switch (type) {
    case 'odds-asc':
      return 'Low Odds First';
    case 'odds-desc':
      return 'High Odds First';
    case 'stats-asc':
      return 'Low % First';
    case 'stats-desc':
      return 'High % First';
    default:
      return name;
  }
}

export const convertNameForStatsPerform = (typeName: string | null) => {
  switch (typeName) {
    case 'First Basket Scorer':
      return 'First Basket';
    case 'Player Points':
    case 'Player Rebounds':
    case 'Player Assists':
    case 'Player Threes':
    case 'Player Steals':
    case 'Player Blocked Shots':
    case 'Player Turnovers':
    case 'Player Assists + Rebounds':
    case 'Player Points + Rebounds':
    case 'Player Points + Assists':
      return `${typeName} Line`;
    case 'Player Double-Double':
      return 'Double-Double';
    case 'Player Triple-Double':
      return 'Triple-Double';
    default:
      return typeName;
  }
}
